import {startRouter} from "./code/routing/Router.ts";

startRouter();